import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Avatar.module.scss";
import Image from "../Image";
import classNames from "classnames";
import { Icon } from "../Icon/Icon";
const Avatar = ({ className, person, avatarSize, onClick, style, ...rest }) => {
    const userInitials = `${(person.first_name && person.first_name.replace(/[()/*]*/gi, "")[0]) || ""}${(person.last_name && person.last_name[0]) || ""}`.toUpperCase();
    let a11yLabel = `Avatar of ${fullName(person.first_name, person.last_name)}`;
    const [isImageHide, setIsImageHide] = useState(false);
    useEffect(() => {
        setIsImageHide(false);
    }, [person.thumbnail]);
    return (React.createElement("div", { className: cn("ukt-avatar", className, styles.avatar), style: {
            width: avatarSize,
            height: avatarSize,
            minWidth: avatarSize,
            minHeight: avatarSize,
            ...style,
        }, onClick: onClick, ...rest }, person.thumbnail && !isImageHide ? (React.createElement(Image, { onError: () => setIsImageHide(true), src: person.thumbnail, alt: a11yLabel })) : Boolean(userInitials) ? (React.createElement("div", { "aria-label": a11yLabel, className: classNames(parseInt(avatarSize) <= 32 && "typography-small__t") }, userInitials)) : (React.createElement(Icon, { className: classNames("icon profile-icon bg-main-color", parseInt(avatarSize) <= 32 && "h-4 w-4") }))));
};
function fullName(firstName, lastName) {
    return [firstName, lastName].filter(Boolean).join(" ");
}
export default Avatar;
//# sourceMappingURL=Avatar.js.map